<template>
    <div class="publication__cards content-width d-flex">
        <div class="publication__card d-flex"
             :class="{'publication__card--selected': selected === _item.key}" v-for="(_item, _idx) in initial">

            <div class="publication__card-left">
                <div class="publication__card-header  d-flex">
                    <img :src="_item.icon" class="publication__card-icon" alt="" v-if="_item.icon">
                    <h3 class="publication__card-title" v-text="_item.title"></h3>
                </div>

                <div class="publication__card-description" v-text="_item.description" ></div>
            </div>
            <div class="publication__card-right d-flex">
                <a :href="_item.link" class="btn publication__btn" v-if="_item.link">Выбрать</a>
                <a href="#" class="btn publication__btn" v-if="selected !== _item.key"
                   @click.prevent="$v.selected.$model = _item.key;"
                   >Выбрать</a>
                <a href="#" @click.prevent="$v.selected.$model = null"
                   class="btn publication__btn publication__btn--selected" v-if="selected === _item.key">Отмена</a>
            </div>

        </div>

        <div class="text-danger" v-if="$v.selected.$error" >Укажите тип обьявления.</div>

    </div>
</template>

<script>


const createPetVerify = {
    device: {
        key: 'device', title: 'Пристройство',
        description: 'Публикация животного, которое ищет новый дом или собирает средства. Отображается в каталоге и в первых двух блоках главной страницы',
    },
    fundraising: {
        key: 'fundraising', title: 'Пристройство и сбор средств',
        description: 'Публикация животного которое собирает средство на лечение, содержание или еду. Доступно после прохождения верификации.',
    },
};

import { required } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationCreatePet",
    props: ['server'],
    mixins: [StateMixin],
    computed: {

        initial() { return createPetVerify },

        selected: {
            get() { return this.GET_BY_KEY('create_category') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'create_category', data: val})
            }
        }

    },

    methods:{
        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return  false
            }

            this.$emit('parent-update', true )
            return  true
        }

    },

    validations: { selected: { required } }

}
</script>

<style scoped>

</style>
